cb.define([], function() {
	var ST_st_storecheckreview_VM_Extend = {

		doAction: function(name, viewmodel) {
			if(this[name]) {
				this[name](viewmodel);
			}
		},
		init: function(viewmodel) {

			/*let gridModel = viewmodel.getGridModel();

			//afterInit事件中取父viewmodel
			var parentViewModel;
			viewmodel.on('afterInit', function(args) {
				parentViewModel = viewmodel.getCache('parentViewModel');

				//按钮可见性
				var storecheckplanstatus = parentViewModel.get('status').getValue();
				if(storecheckplanstatus != null && storecheckplanstatus != undefined && storecheckplanstatus !== '' && storecheckplanstatus == 0) {
					//未复核状态（status = 0）下，复核按钮和复盘按钮可见  联查按钮不可见
					viewmodel.get('btnReAudit').setVisible(true);
					viewmodel.get('btnReCheck').setVisible(true);
					viewmodel.get('btnQueryOthOut').setVisible(false);
					viewmodel.get('btnQueryOthIn').setVisible(false);
				} else {
					//否则复核按钮和复盘按钮不可见  联查按钮可见
					viewmodel.get('btnReAudit').setVisible(false);
					viewmodel.get('btnReCheck').setVisible(false);
					viewmodel.get('btnQueryOthOut').setVisible(true);
					viewmodel.get('btnQueryOthIn').setVisible(true);
				}
			});

			//复盘
			viewmodel.on('recheck', function(args) {
				debugger
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == null || selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('请选择需要复盘的商品！', 'warning');
					return false;
				}
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var datas = {
					billnumber: "st_storecheckreviewlist",
					storecheckplan: parentViewModel.get('id').getValue(),
					tenant: cb.rest.AppContext.tenant.id,
					store: parentViewModel.get('store').getValue(),
					warehouse: parentViewModel.get('warehouse').getValue(),
					selectedRows: selectedRows
				}
				var params = {
					billnum: "st_storecheckreviewlist",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != null) {
						cb.utils.alert(result, 'success');
					}
					viewmodel.execute('refresh');
				});

			});

			//复核
			viewmodel.on('reaudit', function(args) {
				var url = '/bill/reaudit';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});

				var datas = {
					billnumber: "st_storecheckreviewlist",
					storecheckplan: parentViewModel.get('id').getValue(),
					tenant: cb.rest.AppContext.tenant.id,
					store: parentViewModel.get('store').getValue(),
					warehouse: parentViewModel.get('warehouse').getValue()
				}
				var params = {
					billnum: "st_storecheckreviewlist",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					viewmodel.get('btnReAudit').setVisible(false);
					viewmodel.get('btnReCheck').setVisible(false);
					viewmodel.get('btnQueryOthOut').setVisible(true);
					viewmodel.get('btnQueryOthIn').setVisible(true);
					viewmodel.execute('refresh');
				});
			});

			//联查其他出库单
			viewmodel.on('queryothout', function(args) {
				var originid = parentViewModel.get('id').getValue();
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'queryothout',
					billnum: 'st_storecheckplan',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					if(result != undefined) {
						cb.utils.alert('操作成功', 'success');
						viewmodel.execute('refresh');
						var params = {
							mode: 'edit',
							readOnly: true,
							id: JSON.parse(result).id
						};
						var data = {
							billtype: 'voucher',
							billno: JSON.parse(result).billno,
							params: params
						};
						cb.loader.runCommandLine('bill', data, viewmodel);
					}

				});
			});
			//联查其他入库单
			viewmodel.on('queryothin', function(args) {
				var originid = parentViewModel.get('id').getValue();
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: args.cSvcUrl,
						method: args.cHttpMethod
					}
				});
				var params = {
					action: 'queryothin',
					billnum: 'st_storecheckplan',
					data: JSON.stringify(originid)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
					var params = {
						mode: 'edit',
						readOnly: true,
						id: JSON.parse(result).id
					};
					var data = {
						billtype: 'voucher',
						billno: JSON.parse(result).billno,
						params: params
					};
					cb.loader.runCommandLine('bill', data, viewmodel);
				});
			});

			gridModel.on('beforeLoad', function(data) {
				if(!data.condition.commonVOs) {
					data.condition.commonVOs = [];
				}
				//遍历每一个commonVos,如果含有漏盘依据的过滤项，
				//那么1.修改simpleVOs的默认设置（默认按照存量看漏盘）使根据漏盘依据过滤项设置的值进行过滤
				//2.移除该过滤项，因为该过滤项在后台没有对应的数据源，会报错
				var commonVOs2 = [];
				var index = 0;
				var haveUncheckBasis = 0;
				for(var i = 0; i < data.condition.commonVOs.length; i++) {
					if(data.condition.commonVOs[i].itemName.equalsIgnoreCase('uncheckBasis')) {
						haveUncheckBasis = 1;
						if(data.condition.commonVOs[i].value1 == 0) { //按存量看漏盘
							if(!data.condition.simpleVOs) {
								data.condition.simpleVOs = [];
							}
							var simpleVOs2 = [];
							var exists = 0;
							var index2 = 0;
							for(var j = 0; j < data.condition.simpleVOs.length; j++) {
								if(data.condition.simpleVOs[j].field.equalsIgnoreCase('resultdetails.stockbasis')) {
									data.condition.simpleVOs[j].value1 = '1';
									exists = 1;
								}
								//去除按门店经营范围看漏盘的vo
								if(data.condition.simpleVOs[j].field.equalsIgnoreCase('resultdetails.productbasis')) {

								} else {
									simpleVOs2[index2] = data.condition.simpleVOs[j];
									index2++;
								}
							}
							if(exists == 0) {
								simpleVOs2.push({
									field: 'resultdetails.stockbasis',
									op: 'eq',
									value1: '1'
								});
							}
							data.condition.simpleVOs = simpleVOs2;

						} else if(data.condition.commonVOs[i].value1 == 1) { //按门店经营范围看漏盘
							if(!data.condition.simpleVOs) {
								data.condition.simpleVOs = [];
							}
							var simpleVOs2 = [];
							var exists = 0;
							var index2 = 0;
							for(var j = 0; j < data.condition.simpleVOs.length; j++) {
								if(data.condition.simpleVOs[j].field.equalsIgnoreCase('resultdetails.productbasis')) {
									data.condition.simpleVOs[j].value1 = '1';
									exists = 1;
								}
								//去除按存量看漏盘的vo
								if(data.condition.simpleVOs[j].field.equalsIgnoreCase('resultdetails.stockbasis')) {

								} else {
									simpleVOs2[index2] = data.condition.simpleVOs[j];
									index2++;
								}
							}
							if(exists == 0) {
								simpleVOs2.push({
									field: 'resultdetails.productbasis',
									op: 'eq',
									value1: '1'
								});
							}
							data.condition.simpleVOs = simpleVOs2;
						}
					} else {
						commonVOs2[index] = data.condition.commonVOs[i];
						index++;
					}

				}
				data.condition.commonVOs = commonVOs2;

				if(haveUncheckBasis == 0) { //漏盘依据的条件被清空，那么将simplevos中的漏盘依据默认值去掉
					if(!data.condition.simpleVOs) {
						data.condition.simpleVOs = [];
					}
					var simpleVOs3 = [];
					var index3 = 0;
					for(var j = 0; j < data.condition.simpleVOs.length; j++) {
						if(data.condition.simpleVOs[j].field.equalsIgnoreCase('resultdetails.productbasis') || data.condition.simpleVOs[j].field.equalsIgnoreCase('resultdetails.stockbasis')) {

						} else {
							simpleVOs3[index3] = data.condition.simpleVOs[j];
						}
						data.condition.simpleVOs = simpleVOs3;
					}

				}

				var storeCheckRange = parentViewModel.get('storeCheckRange').getValue();
				var products = [];
				var productclasses = [];
				if(storeCheckRange == 2) {
					//如果是指定商品盘点，那么需要把计划单中的商品id传到后台去，查出存量表中的该商品对应的skuid，并且剔除存在于其他未复核
					//的盘点计划中的sku，（上述操作在后台复用盘点计划调用的方法就行了）
					//然后与实盘汇总结果比较，选出漏盘的商品
					var productrows = parentViewModel.get('details').getData();
					if(productrows != 'undefined' && productrows != null && productrows.length > 0) {
						for(var i = 0; i < productrows.length; i++) {
							products[i] = productrows[i].product;
						}
					}
				} else if(storeCheckRange == 1) { //指定品类盘点,把分类id传到后台
					var productclassrows = parentViewModel.get('productClass').getData();
					if(productclassrows != 'undefined' && productclassrows != null && productclassrows.length > 0) {
						for(var i = 0; i < productclassrows.length; i++) {
							productclasses[i] = productclassrows[i].productClass;
						}
					}
				}
				var params = {
					//如果后台发现这个字段是1即已复核，那么就不会再拼装盘点复核的临时表了
					rechecked: parentViewModel.get('status').getValue(),
					storecheckplan: parentViewModel.get('id').getValue(),
					tenant: cb.rest.AppContext.tenant.id,
					store: parentViewModel.get('store').getValue(),
					warehouse: parentViewModel.get('warehouse').getValue(),
					createTime: parentViewModel.get('createTime').getValue(),
//					checkEndTime: parentViewModel.get('checkEndTime').getValue(),
					storeCheckRange: storeCheckRange,
//					products: products,
//					productclasses: productclasses,
					billnumber: 'st_storecheckreviewlist'
				};
				
				if(products.length > 0){
					params["products"] = products;					
				}
				if(products.length > 0){
					params["productclasses"] = productclasses;					
				}
				
				data.externalData = params;

			});*/
		},

	}
	try {
		module.exports = ST_st_storecheckreview_VM_Extend;
	} catch(error) {

	}
	return ST_st_storecheckreview_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckreview_VM.Extend.js